import {
    SET_HORIZON_LENGTH, SET_SELECTED_FINANCING,
    SET_PIE_SLIDER, TOGGLE_ANNUAL_MONTH, TOGGLE_LOADING,
    TOGGLE_DELETE, TOGGLE_PROPOSAL_VIEW,
} from './constants';

const defaultState = {
    horizonLength: 30,
    selectedFinancing: 0,
    doughnutSlider: 1,
    annualMonth: true,
    loading: false,
    toggleDelete: false,
    toggleView: true,
};

const settings = (state = defaultState, action) => {
    switch (action.type) {
        case SET_HORIZON_LENGTH:
            return { ...state, horizonLength: action.horizonLength };

        case SET_SELECTED_FINANCING:
            return { ...state, selectedFinancing: action.selectedFinancing };

        case SET_PIE_SLIDER:
            return { ...state, doughnutSlider: action.doughnutSlider };

        case TOGGLE_ANNUAL_MONTH:
            return { ...state, annualMonth: action.annualMonth };

        case TOGGLE_LOADING:
            return { ...state, loading: action.loading };

        case TOGGLE_DELETE:
            return { ...state, toggleDelete: action.toggleDelete };
        case TOGGLE_PROPOSAL_VIEW:
            return { ...state, toggleView: action.toggleView };


        default:
            return state;
    }
};

export default settings;



// WEBPACK FOOTER //
// ./src/containers/common/settings/reducer.js